import { siteMeta, footerLinks, siteContact } from '@/mocks/gossipData';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-800 text-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr]">
          {/* Brand */}
          <div>
            <a href="#today" className="flex items-center gap-2.5" aria-label="昨日吃瓜 返回顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-background-50 text-primary-700">
                <i className="ri-water-flash-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">{siteMeta.brand}</span>
                <span className="mt-1 text-[11px] text-background-300">{siteMeta.tagline}</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-6 text-background-300">{siteMeta.intro}</p>
          </div>

          {/* Link col 1 */}
          {footerLinks.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.items.map((it, i) => (
                  <li key={i}>
                    <a
                      href={it.href}
                      className="inline-flex items-center gap-1.5 text-sm text-background-300 transition-colors hover:text-background-50"
                    >
                      <i className="ri-arrow-right-s-line text-accent-300" />
                      {it.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          {/* Contact */}
          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">联系与投稿</h3>
            <p className="mt-4 text-sm leading-6 text-background-300">{siteContact.desc}</p>
            <a
              href={`mailto:${siteContact.email}`}
              className="mt-3 inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-2 text-sm font-medium text-background-100 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-mail-line text-accent-200" /> {siteContact.email}
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-300">
            © {year} {siteMeta.brand} · 专注昨日瓜田盘点，内容以公开信息整理，转载与投稿请联系我们。
          </p>
          <div className="flex items-center gap-2">
            <a
              href="#top"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-4 py-2 text-xs font-medium text-background-100 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-arrow-up-line" /> 返回顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}